import { useState } from "react";
import Subhero from "../components/subhero/subhero";
// import Media from "../components/Home/media/media";
import Modes from "../components/Home/modes/modes";
import Scroll from "react-scroll";
import Crossplay from "../components/Home/crossplay/crossplay";
import Discover from "../components/Home/discover/discover";
import Download from "../components/Home/download/download";
import Animals from "../components/Home/animals/animals";
// import Create from "../components/create/create";
import Footer from "../components/footer/footer";
import Subfooter from "../components/footer/subfooter";
import Hero from "../components/Home/hero/hero";

const Element = Scroll.Element;

function HomePage() {
  const [openDownload, setOpenDownload] = useState(false);

  return (
    <div className="bg-darkslate">
      <Hero openDownload={openDownload} setOpenDownload={setOpenDownload} />
      <Footer />
      <Download openDownload={openDownload} setOpenDownload={setOpenDownload} />
    </div>
  );
}

export default HomePage;